module.exports = __webpack_public_path__ + "img/geofisica3_4-3.5f323e92.jpg";